import React, { useContext, useLayoutEffect } from 'react';
import { Checkbox, Col, ConfigProvider, Flex, Row, Select, Dropdown, Menu, Button, Modal, Popover, Breadcrumb, TableColumnProps, message, App } from 'antd';
import zh_CN from 'antd/locale/zh_CN';
import { useUpdateEffect } from 'ahooks'
import { Pagination } from 'antd';
import CommonReportMobile from './mobile/ReportMobile';
import { FilterPc } from '@/component/Filter/FilterPc';
import { StyleProvider } from '@ant-design/cssinjs';
import { DataCard } from '@/component/Report/Display/Display';
import { DhbFilterForm, DhbFooterProps } from '@/component/PageComponent/PageComponent';
import 'dayjs/locale/zh-cn';
import {  QuickBiReportDataResponse, serviceQuickBiReportConfig, serviceQuickBiReportData } from '@/component/Report/services/bi/bi';
import { serviceQuickBiReportTemplate } from '@/component/Template/services/template';
import { AlertModule, CardModule, CustomReportConfig, FilterModule, LineChartModule, TableModule } from '../../component/common/report/reportConfigModel';
import { PageInfoBase, useGetData } from '@/component/PageComponent/hooks/requst';
import dayjs from 'dayjs'
import { isError } from '@/component/common/error';
import _, { isFunction } from 'lodash';
import { CustomLineChart } from '@/component/Report/LineCart/LineCart';
import { BaseTable } from '@/component/Report/CustomTable/BaseTable/BaseTable';
import { CustomCard } from '@/component/Report/CustomCard/CustomCard';
import { configMock, reportConfigMock } from './reportConfigMock';
import { QuestionCircleOutlined  } from '@ant-design/icons'
import styled from 'styled-components';
import { useParams, useLocation  } from 'react-router-dom'
import { requestLoading } from '@/hooks/hooksPc/useRequestLoadingPc';
import { SortOrder } from 'antd/es/table/interface';
import { convertSortValues, CountType, getSource, isValidTableBaseParams, TableBaseParamsType } from '@/component/Report/share/params';
import { getTransmferFields, pageInfoStore } from '@/component/Report/CustomTable/utils/utilsTable';
import { AlertMenu } from '@/component/Alert/AlertMenu/AlertMenu';
import {  useLowBrowserMessage } from './hooks';
import { sessionStorageCustom, StorageCustomInstance } from '@/utils/utils';
import { ReportConfig,ServiceQuickBiReportDataParams,ReportParams ,getDefaultParams, getSearchParams, getSearchTimestamp, encryptReportFilterSelectParams, encryptUrlSelectValue, encryptReportRequestParams} from '@/component/common/report/report';
import UrlParamsContext, { UrlParamsContextType } from '../../context/urlParamsContext';
import { FilterAll, FilterTypes } from '@/component/FilterCommon/Filter';
import { AiSummary } from '@/component/Report/AISummary/AISummary';
import { AlertModule as AlertModuleView } from '@/component/AlertModule/AlertModule';
import  { TextTitleModule } from '@/component/TextModule/TextTitle';


// type SortParams = {dataIndex:string, order:  'descend' | 'ascend' | null | undefined}[]
// export type ReportParams = {
//   sortParams?: SortParams
//   [x:string]: string| SortParams | undefined|number,
// }

const DhbBreadView = styled.div`
  &.dhb-bread{
    background-color: #fff;
    display: flex;
    height: 60px;
    align-items: center;
    /* margin-bottom: 10px; */
    border-bottom: 1px solid #f0f0f0;
    padding: 0 15px;
    flex-shrink: 0;
    .dhb-bread-title{
      margin-right: 20px;
      font-size: 24px;
      color: #000;
      vertical-align: sub;
    }

  }

`
const AlertMenuView = styled.div`
  width: 200px;
  flex-shrink: 0;
  background: #fff;
  border-right: 1px solid #f0f0f0;
  margin-right: 15px;

`


interface DhbBreadProps {
  reportConfig: ReportConfig | undefined
}

interface StorageParamsType {
  tableBaseParams: TableBaseParamsType,
  params: ReportParams,
  pageInfo: PageInfoBase, 
  timeStamp: string
}


const DhbBread = (props:DhbBreadProps) => {
  const {reportConfig} = props
  if(!reportConfig){
    return null
  }
  const {help_info,report_config} = reportConfig.config
  const defaultBreadCrumb = ()=>{
    const breadCrumbs =  ['数据']
    if(report_config.alertMenu){
      breadCrumbs.push('数据预警分析')
    }
    return breadCrumbs
  }
  let breadCrumbs = report_config.breadCrumbs || defaultBreadCrumb()

  return <DhbBreadView className="dhb-bread">
    <span className="dhb-bread-title">{reportConfig.config.report_name}</span>
    { help_info && <Popover placement="bottomLeft" content={<div style={{whiteSpace:'pre-wrap'}} dangerouslySetInnerHTML={{__html:help_info}}></div>}>
      <QuestionCircleOutlined  style={{marginRight:'10px'}}/>
    </Popover>}
    <Breadcrumb>
      {/* <Breadcrumb.Item><NavLink to="/Manager/home">首页</NavLink></Breadcrumb.Item> */}
      <Breadcrumb.Item>首页</Breadcrumb.Item>
      { breadCrumbs.map((item,index)=><Breadcrumb.Item key={index} >{item}</Breadcrumb.Item>)}
      {/* <Breadcrumb.Item>数据</Breadcrumb.Item>
      { reportConfig.config.report_config.alertMenu && <Breadcrumb.Item>数据预警分析</Breadcrumb.Item> } */}
    </Breadcrumb>
  </DhbBreadView>
}

type PageParams =Omit<ServiceQuickBiReportDataParams,'source'>


const postMessageToParent = (data:ReportConfig)=>{
  window.parent.postMessage({ type: 'reportConfig',data:data }, '*');
}
let storagePage = pageInfoStore.get()
const pageSize = storagePage ? Number(storagePage) : 10

const pageStore = new StorageCustomInstance<StorageParamsType>()
export default () => {

  let {reportName = ''} = useParams<{reportName:string}>()
  const location = useLocation()
  const isAiChat = new URLSearchParams(location.search).get('render-type') === 'ai-chat'
  const [contextData, setContextData] = React.useState<Array<UrlParamsContextType>>([])

  // const [params, setParams] = React.useState({})
  const [configData,setConfig] = React.useState<ReportConfig|undefined>()
  const configDataRef = React.useRef<ReportConfig|undefined>()
  // const [reportData, setReportData] = React.useState<QuickBiReportDataResponse>();
  const [count, setCount] = React.useState<number>();
  const [reportTableData,setReportTableData] = React.useState<Array<Record<string,string|number>>>();
  // const [menuItem,setMenuItem] = React.useState(configData?.config.report_config.alertMenu?.menu[0])


  const tableBaseParamsRef = React.useRef<TableBaseParamsType>({})
  const defaultParamsRef = React.useRef<PageParams|undefined>()

  const getParamsStorageKey = (accounts_id:string)=>`page_storage_${accounts_id}_${reportName}`
  useLowBrowserMessage()
  // AI Chat 模式下的空数据获取函数
  const getAiChatData = async (params: PageParams) => {
    // AI Chat 模式下不需要请求数据，直接返回
    return Promise.resolve()
  }

  const getQuickBiReportData = async (params: PageParams) => {
    if(params.count==undefined){
      params.count=CountType.isRequestAll
    }
    if(!isValidTableBaseParams(tableBaseParamsRef.current)){
      return
    }
    let transformer_fields = getTransmferFields(configDataRef.current);
    const requestParams = encryptReportRequestParams({
      configData: configDataRef.current,
      requestParams: params,
    })

    async function getBiReportList (tableBaseParams:Required<TableBaseParamsType>){
      const { source_count,...rest } = tableBaseParams
      let reportData =  await requestLoading(
        serviceQuickBiReportData({ ...requestParams, ...rest, transformer_fields, count: CountType.isRequestTable, })
      )
      if (isError(reportData)) {
        return
      }
      setReportTableData(reportData.data.listsData)
    }
    async function getBiReportCount(tableBaseParams:Required<TableBaseParamsType>){
      let { source,source_count,...rest} = tableBaseParams
      let hasSourceCount = !!source_count
      let count = CountType.isRequestCount
      if(hasSourceCount){
        source = source_count
        // 特定count数据源的count字段返在list上面，特殊处理
        count = CountType.isRequestTable
      }
      let collaborator_company_id = params.collaborator_company_id  as  number
      let reportData = await serviceQuickBiReportData({ ...requestParams, ...rest, source, transformer_fields,count:  count, collaborator_company_id });
      if(hasSourceCount){
        let countObj = reportData.data.listsData[0] || {}
        let countNumber = Number(countObj.count || 0)
        setCount(countNumber)
        return
      }
      setCount(reportData.data.count)
    }

    if(params.count == CountType.isRequestTable){
      getBiReportList(tableBaseParamsRef.current)
    }
    if(params.count == CountType.isRequestAll){
      getBiReportList(tableBaseParamsRef.current)
      getBiReportCount(tableBaseParamsRef.current)
    }
  }
  
  // 根据 isAiChat 选择使用哪个数据获取函数
  const dataHandler = useGetData<ReportParams>({
    getData: isAiChat ? getAiChatData : getQuickBiReportData, 
    defaultPageInfo:{ page:1,pageSize } 
  })




  const {params, setParams, setPageInfo, pageInfo ,loading} = dataHandler 
  const getConfig = async () => {
    let resConfig = await serviceQuickBiReportConfig({report: reportName,   })
    if(isError(resConfig)){
      return
    }
    let configData = resConfig.data
    if(process.env.NODE_ENV === 'development'){
      // configData = reportConfigMock
    }
    encryptReportFilterSelectParams({ configData })
    postMessageToParent(configData)
    const isAffilliate = configData.first_collaborator_company_id && Number(configData.first_collaborator_company_id) > 0
    // if(!isAffilliate){
    //   configData.first_collaborator_company_id = undefined
    // }
    let {defaultParams,report_config} = getDefaultParams(configData)

    // 处理url上的search参数
    const urlDefaultParamsArray = getSearchParams() as Array<UrlParamsContextType>;
    setContextData(urlDefaultParamsArray);
    // const a = urlDefaultParamsArray.map(item => )
    // if(isAffilliate){
    //   defaultParams.collaborator_company_id = configData.first_collaborator_company_id
    // }
    if(report_config){
      configData.config.report_config = report_config
    }
    let formatValue = (value:string|number,valueType: UrlParamsContextType['valueType'])=>{
      if(value === undefined || value == null){
        value = ''
      }
      if(valueType == "string"){
        return value.toString()
      }
      if(valueType == 'number'){
        return Number(value)
      }
      return value
    }
    let filterConfig = configData.config.report_config.modules.find(item => item.type == 'filter') 
    const searchParams = urlDefaultParamsArray.reduce((pre, curr) => {
      let value: string| Array<string> = (typeof curr.value === 'string' || typeof curr.value === 'number') ? [curr.value] : curr.value;
      let currentFilter: FilterAll | undefined
      if(filterConfig && filterConfig.type == 'filter'){
        currentFilter = filterConfig.list.find(item => item.dataIndex == curr.dataIndex)
        if(currentFilter){
          if(currentFilter.singleMode || currentFilter.type == FilterTypes.Input){
            value = curr.value
          }
        }
      }
      let valueType = curr.valueType
      let dataIndexValue: Array<string|number>|string| number = value
      if(valueType){
        if(Array.isArray(value)){
          dataIndexValue = value.map(item => formatValue(item,valueType))
        }else{
          dataIndexValue = formatValue(value,valueType)
        }
      }
      dataIndexValue = encryptUrlSelectValue({
        filterItem: currentFilter,
        value: dataIndexValue,
        valueType,
      })
      return { ...pre, [curr.dataIndex]: dataIndexValue };
    }, {});

    defaultParamsRef.current = _.cloneDeep({...defaultParams, ...searchParams})
    
   
    setConfig(configData)
    configDataRef.current = configData
    let report = configData?.config.slug
    let {source,template_code,menuItem,source_count} = getSource(configData?.config.report_config)

    tableBaseParamsRef.current = {
      report,source,template_code,source_count
    }
    pageStore.updateKey(getParamsStorageKey(configData.accounts_id))
    let storeCache = pageStore.getItem();

    if(storeCache && Object.keys(storeCache).length){
      let {timeStamp,tableBaseParams,params,pageInfo} = storeCache

      // 判断时间戳是否相等
      const serchTimeStamp = getSearchTimestamp();
      if((serchTimeStamp !== timeStamp)){
        setParams({...defaultParamsRef.current,count: CountType.isRequestAll})
        return
      }

      if(isAffilliate){
        params.collaborator_company_id = configData.first_collaborator_company_id
      }
      if(tableBaseParams){
        tableBaseParamsRef.current = tableBaseParams
      }
      //延迟读取configData
      // setTimeout(()=>{
      //   dataHandler.setParamsAndPageInfo({...params,count: CountType.isRequestAll},pageInfo)
      // })
      dataHandler.setParamsAndPageInfo({...params,count: CountType.isRequestAll},pageInfo)

      // dataHandler.setParams({...params,count: CountType.isRequestAll})
      // dataHandler.setPageInfo(pageInfo)
      return
    }
    setParams({...defaultParamsRef.current,count: CountType.isRequestAll})
    //延迟读取configData
    // setTimeout(()=>{
    //   setParams({...defaultParamsRef.current,count: CountType.isRequestAll})
    // })
    // setMenuItem(menuItem)
    // return config
  }
  React.useEffect(()=>{
    if(configData){
      const timeStamp = getSearchTimestamp();
      
      let storageParams = { params, pageInfo, tableBaseParamsRef:tableBaseParamsRef.current } as unknown as StorageParamsType;
      if (timeStamp) {
        storageParams.timeStamp = timeStamp;
      }
      sessionStorageCustom.setItem(getParamsStorageKey(configData.accounts_id), storageParams)
    }

  },[params, pageInfo])

  React.useEffect(()=>{
    getConfig()
  },[])
  // 监听父窗口的 postMessage，接收并设置 searchParams
  React.useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const payload = event.data;
      if (!payload || typeof payload !== 'object') return;
      if (payload.type === 'setSearchParams') {
        const searchParams = payload.data?.searchParams;
        if (searchParams && typeof searchParams === 'object') {
         setParams({
            ...params,
            ...searchParams,
            sortParams: params.sortParams,
            count: CountType.isRequestAll,
          })
        }
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [setParams]);

  const [aiSearchSignal, setAiSearchSignal] = React.useState<number>(0); // 新增：AI触发信号
  const triggerAiSearch = React.useCallback(() => {
    setAiSearchSignal(s => s + 1); // 每次点击自增，触发子组件监听
  }, []);

  function renderFilter(moduleItem:FilterModule){
    let { list,rowFlex } = moduleItem
    let filterList = list.map(item =>{
      if(!configData?.first_collaborator_company_id){
        return item
      }
      return {
        collaborator_company_id: configData?.first_collaborator_company_id,
        company_id: configData?.company_id,
        ...item,
      }
    })
    return <div style={{marginBottom:'15px'}} key={moduleItem.type}>
      <DhbFilterForm
        isAiChat={isAiChat}
        isMainFilter={true}
        params={params}
        onSearch={(_params, notRunAsync?: boolean) => {
          setParams({..._params,sortParams: params.sortParams,count: CountType.isRequestAll}, notRunAsync)
        }}
        externalTriggerAiSearch={aiSearchSignal} // 新增：把信号传给 PageComponent
        defaultParams={defaultParamsRef.current}
        filterProps={{
          rowFlex,
          filters: filterList,
        }}
    /></div>
  }

  function renderModules (){
    if(!configData){
      return null
    }      
    return configData?.config.report_config.modules?.map(moduleItem=>{
      // AI报表只渲染filter模块
      if (isAiChat) {
        if (moduleItem.type == 'filter') {
          return renderFilter(moduleItem)
        }
        return null
      }
      if(moduleItem.type === 'table' && reportTableData){
        return <BaseTable key={moduleItem.type} loading={loading} source={ tableBaseParamsRef.current.source || ''} reportConfig={configData} reportTableData={reportTableData} moduleItem={moduleItem} count={count} params={params} dataHandler={dataHandler}/>
      }
      if(moduleItem.type == 'card'){
        return <CustomCard   key={moduleItem.type}  reportConfig={configData} moduleItem={moduleItem}  dataHandler={dataHandler}  style={{margin:'0px 0 15px 0',width:'100%'}} />
      }
      if(moduleItem.type == 'lineChart' && reportTableData){
        return <CustomLineChart  key={moduleItem.type}  reportConfig={configData} moduleItem={moduleItem} params={params} reportTableData={reportTableData} />
      }
      if (moduleItem.type == 'filter') {
        return renderFilter(moduleItem)
      }
      if (moduleItem.type == 'alert') {
        const resolvedModuleItem = {
          ...moduleItem,
          source: moduleItem.source ?? tableBaseParamsRef.current.source ?? '',
        }
        return (
          <AlertModuleView
            key={moduleItem.type}
            reportConfig={configData}
            moduleItem={resolvedModuleItem}
            dataHandler={dataHandler}
            wrapperStyle={moduleItem?.wrapperStyle}
          />
        )
      }
      if (moduleItem.type == 'textTitle') {
        return <TextTitleModule key={moduleItem.type} moduleItem={moduleItem}  />
      }
      // 新增渲染：AI智能总结模块
      if (moduleItem.type === 'aiSummary') {
        return (
          <AiSummary
            key={moduleItem.type}
            reportConfig={configData}
            moduleItem={moduleItem}
            params={params}
            loading={loading}
            templateCode={tableBaseParamsRef.current.template_code}
            selectedReport={reportName}
            onTriggerAiSearch={triggerAiSearch}
          />
        )
      }
    })
  }


  const renderPageComponent = ()=>{
    const { alertMenu } = configData?.config.report_config || {}
    let isShowAlertMenu = alertMenu?.show
    if(isShowAlertMenu){
      let menuItem = alertMenu?.menu.find(item=>item.key == tableBaseParamsRef.current.source)
      return <Flex style={{flex:1,overflow:'hidden'}}>
        <AlertMenuView>
          <AlertMenu
            report={configData!.config.slug}
            alertMenu={alertMenu}
            menuItem={menuItem}
            onChangeVariable={(variable)=>{
              setConfig(_config=>{
                if(!_config)return _config
                let configData = {..._config}
                configData.config.report_config.alertMenu!.variable = {...variable}
                return {
                  ...configData,
                }
              })
            }}
            onChangeAlertMenuItem={(menuItem)=>{
              tableBaseParamsRef.current.source = menuItem.key
              // setMenuItem(menuItem)
              setParams({...params,count: CountType.isRequestAll})
            }}
          />
        </AlertMenuView>
       <div style={{flex:1,overflowX:'hidden',display:'flex',flexDirection:'column'}}>{renderModules()}</div>
      </Flex>
    }
    return  renderModules()
  }
  return (
    <Flex  vertical style={{ background: isAiChat ? '#FFFFFF' : '#f0f0f0',boxSizing:'border-box', height:'100vh' }}>
      <ConfigProvider
        locale={zh_CN}
        theme={{
          components:{
            Table:{
              rowHoverBg: "#fff5f0"
            }
          },
          token: {
            colorPrimary: '#FF7557',
          }
        }}
      >
        {!isAiChat && <DhbBread reportConfig={configData}/>}
        <UrlParamsContext.Provider value={contextData}>
          { renderPageComponent() }
        </UrlParamsContext.Provider>
      </ConfigProvider>
    </Flex>
  );
};
